import { StapleTable, StapleTableCell } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StapleTableStyled = styled(StapleTable)`
  width: max(100%, 90rem);
`;

export const ActionCellStyled = styled(StapleTableCell)`
  text-align: right;
`;
